import { call, put, takeLatest } from 'redux-saga/effects';
import * as QueryParams from 'query-string';
import { callApiWithNoAuth, request } from '../../api/Api';
import { getConfig } from '../../services/environment';
import { stopLoading, showErrorMessage, startLoading } from '../layout/action';
import { GET_AMERICAN_STATES, setAmericanStates, setToken } from './action';


export function* callGetAmericanStates(action){
    try{
       yield put(startLoading())
      //  let data={
      //  client_id: getConfig.clientId,
      //  client_secret: getConfig.clientSecret,
      //  grant_type: 'password',
      //  password: getConfig.masterUserPassword,
      //  username: getConfig.masterUserName,
      //  }
      //  const response=yield call(request,{
      //    data: QueryParams.stringify(data),
      //    headers: {
      //      'Content-Type': 'application/x-www-form-urlencoded',
      //    },
      //    method: 'POST',
      //    url: '/auth/realms/rpe2g/protocol/openid-connect/token',
      //  })
      //  let responseData=response.data ;
        // yield put(setToken(responseData))
       const stateResponse=yield call(callApiWithNoAuth,{
           data:action.payload,
          //  headers: {
          //   'Accept': 'application/json',
          //   'Authorization': `Bearer ${responseData["access_token"]}`,
          //   'Content-Type': 'application/json'
          // },
          method:"GET",
          url:`/api/v1/addresses/states`
       })
       const resultData=stateResponse.data[0]
       yield put(setAmericanStates(resultData.states))
       yield put(stopLoading())
    }catch(err){
        yield put(stopLoading())
        yield put(showErrorMessage({error:err,title:"Get American States Failed"}))
    }
 }

 export function* watchGetAmericanStates(){
    yield takeLatest (GET_AMERICAN_STATES,callGetAmericanStates);
}